import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';

const EmployeeMaster = () => {
  const { selectedFirmId } = useContext(AuthContext);
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Form
  const [editingId, setEditingId] = useState(null);
  const [Emp_name, setEmp_name] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [commission, setCommission] = useState('1');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchEmployees();
  }, [selectedFirmId]);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/masters/employees?firmId=${selectedFirmId}`);
      setEmployees(res.data);
    } catch (err) {
      setError('Failed to load employees');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const payload = {
      Emp_name,
      mobileNo,
      commission: parseFloat(commission) || 1,
      firmid: selectedFirmId
    };

    try {
      if (editingId) {
        await api.put(`/masters/employees/${editingId}`, payload);
        setSuccess('Employee updated successfully');
      } else {
        await api.post('/masters/employees', payload);
        setSuccess('Employee added successfully');
      }
      resetForm();
      fetchEmployees();
    } catch (err) {
      setError('Failed to save employee');
    }
  };

  const handleEdit = (emp) => {
    setEditingId(emp.id);
    setEmp_name(emp.Emp_name || '');
    setMobileNo(emp.mobileNo || '');
    setCommission(emp.commission || '1');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete employee record?')) return;
    try {
      await api.delete(`/masters/employees/${id}`);
      setSuccess('Employee deleted');
      fetchEmployees();
    } catch (err) {
      setError('Failed to delete employee');
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setEmp_name('');
    setMobileNo('');
    setCommission('1');
  };

  const filtered = employees.filter((e) =>
    (e.Emp_name || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
        <div>
          <h3 className="fw-bold mb-1 text-primary">
            <i className="bi bi-person-badge me-2"></i>Employee Master (कामगार / टंडेल)
          </h3>
          <p className="text-muted mb-0">Manage boat crew members, 1st Tandel, Pagi, and commission share points</p>
        </div>
      </div>

      {error && <div className="alert alert-danger py-2">{error}</div>}
      {success && <div className="alert alert-success py-2">{success}</div>}

      <div className="row g-4">
        {/* FORM */}
        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-primary text-white fw-bold">
              {editingId ? 'Edit Employee Details' : 'Add New Employee'}
            </div>
            <div className="card-body">
              <form onSubmit={handleSave}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Employee Name (नाव)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. NITESH 1ST TANDEL / SAHDEV"
                    value={Emp_name}
                    onChange={(e) => setEmp_name(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile Number"
                    value={mobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Commission / Share Points</label>
                  <input
                    type="number"
                    step="0.5"
                    className="form-control"
                    placeholder="1.0"
                    value={commission}
                    onChange={(e) => setCommission(e.target.value)}
                  />
                  <div className="form-text small">
                    Standard: 4 points (1st Tandel), 3 points (2nd Tandel/Pagi), 1 point (Crew)
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button type="submit" className="btn btn-primary w-100 fw-bold">
                    <i className="bi bi-check-circle me-1"></i> {editingId ? 'Update' : 'Save'}
                  </button>
                  {editingId && (
                    <button type="button" className="btn btn-outline-secondary" onClick={resetForm}>
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* LIST */}
        <div className="col-12 col-md-8">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
              <h5 className="fw-bold mb-0 text-dark">
                Crew Directory ({filtered.length})
              </h5>
              <div className="w-50">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search crew..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="table-responsive" style={{ maxHeight: '600px' }}>
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light sticky-top">
                  <tr>
                    <th>#</th>
                    <th>Employee Name</th>
                    <th>Mobile No</th>
                    <th>Share Points</th>
                    <th className="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted">
                        <span className="spinner-border spinner-border-sm me-2"></span> Loading crew directory...
                      </td>
                    </tr>
                  ) : filtered.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted">
                        No employees found.
                      </td>
                    </tr>
                  ) : (
                    filtered.map((e, idx) => (
                      <tr key={e.id}>
                        <td>{idx + 1}</td>
                        <td className="fw-semibold text-primary">{e.Emp_name}</td>
                        <td>{e.mobileNo || '-'}</td>
                        <td>
                          <span className="badge bg-info text-dark fs-6">
                            {e.commission || 1} Share(s)
                          </span>
                        </td>
                        <td className="text-end">
                          <button
                            className="btn btn-outline-primary btn-sm me-1"
                            onClick={() => handleEdit(e)}
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(e.id)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeMaster;
